/* The one page header. Every dashboard screen uses this so the title, the rule
   and the space above it are identical everywhere — Create Notes, Audio Check,
   Templates, Tutorial, Profile and Subscription all used to author their own.

   Heading weight 400 in the display face, hairline rule below — the border was
   #00000047, a 28% black that read as a hard line against the brand's single
   hairline token. The top margin exists because the content wrapper has no
   padding of its own; without it the title sits flush against the viewport.
   The fixed height is what keeps the rule at the same y on every screen — the
   action slot differs per page (a button here, a notification bell there) and
   an intrinsic row would move the rule by a few pixels as you navigate.

   mt-4 + h-12 puts the title's centre at 40px, which is exactly where the
   sidebar lockup's centre sits (the rail's pt-5 plus its h-10 logo row). The two
   are meant to read as one line across the top of the app — change one and you
   must re-check the other. */

const PageHeader = ({ label, children }) => (
  <div className="mb-6 mt-4 flex h-12 items-center justify-between gap-4 border-b border-solid border-rule">
    <h1 className="font-display text-ui-lg font-normal text-ink md:text-h6">{label}</h1>
    {children && <div className="flex flex-shrink-0 items-center gap-3">{children}</div>}
  </div>
);

export default PageHeader;
